"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeOrganization = void 0;
const BusinessRegion_1 = require("../entity/BusinessRegion");
const Organization_1 = require("../entity/Organization");
const createSomeOrganization = ({ id = '3', name = 'Kaizen Platform Some Division', pointBalance = 600, features = { canOpenOfferWhenDisagreed: true }, businessRegion = new BusinessRegion_1.default({
    key: 'jp',
    idBusinessRegion: 'japan',
    timeZone: 'Asia/Tokyo',
}), } = {}) => new Organization_1.default({ id, name, pointBalance, features, businessRegion });
exports.createSomeOrganization = createSomeOrganization;
